module.exports = __webpack_public_path__ + "emaillogo.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/emaillogo.jpg
// module id = 1547
// module chunks = 0